import { Component, OnInit, OnDestroy, DoCheck, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-profile-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Output() completeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() readyChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() prompt:string;
  @Input() slug:string;
  @Input() questioninitmixin:string;
  _complete:boolean=false;
  ready:boolean=false;
  currentSection:string;
  iconClass:string='';

  onNav() {
    if(this.currentSection != this.slug) {
      this.nav.navigateByUrl('/profile/'+this.slug);
      window.scrollTo(300, 500);
    }
  }

  constructor(
    private route: ActivatedRoute,
    private nav: Router
  ){
  }

  @Input()
  set complete(complete:boolean) {
    this._complete=complete;
    this.completeChange.emit(complete);
  }

  get complete():boolean {
    return this._complete;
  }

  ngOnInit() {
    if(!!this.questioninitmixin) {
      if(!!this.questioninitmixin['iconClass']) {
        this.iconClass=this.questioninitmixin['iconClass'];
      }
    }
    this.ready=true;
    this.readyChange.emit(true);
  }

  ngDoCheck() {
    this.route.params.subscribe((params)=>{
      this.currentSection=params.sectionName;
    });
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/sidebar.component.ts